import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "~/css/TracksOnThisDay.less";
import ChimneyName from "~/Components/Elements/ChimneyName";

const TracksOnThisDay = ({ oneYearAgo, twoYearsAgo, threeYearsAgo }) => (
  <Row style={{ marginBottom: 20 }}>
    <Col xs={12}>
      <h2 className="page-header">
        <FontAwesomeIcon icon="calendar" className="cubes fa mr fa-calendar" />
        This Day in History
      </h2>
    </Col>
    <Col xs={12}>
      <Row className="tracksOnThisDay">
        <Col xs={12} md={12} lg={4}>
          <h4>Tracks posted 1 year ago</h4>
          {oneYearAgo &&
            oneYearAgo.map((track) => {
              return (
                <div key={track.id} style={{ marginBottom: 4 }}>
                  <ChimneyName user={track} asLink={false} />: "<Link to={`/${track.id}`}>{track.title}</Link>" by {track.artist}
                </div>
              );
            })}
          {!oneYearAgo || (oneYearAgo.length === 0 && <div>No tracks were posted...</div>)}
        </Col>
        <Col xs={12} sm={12} md={6} lg={4}>
          <h4>Tracks posted 2 years ago</h4>
          {twoYearsAgo &&
            twoYearsAgo.map((track) => {
              return (
                <div key={track.id} style={{ marginBottom: 4 }}>
                  <ChimneyName user={track} asLink={false} />: "<Link to={`/${track.id}`}>{track.title}</Link>" by {track.artist}
                </div>
              );
            })}
          {!twoYearsAgo || (twoYearsAgo.length === 0 && <div>No tracks were posted...</div>)}
        </Col>
        <Col xs={12} sm={12} md={6} lg={4}>
          <h4>Tracks posted 3 years ago</h4>
          {threeYearsAgo &&
            threeYearsAgo.map((track) => {
              return (
                <div key={track.id} style={{ marginBottom: 4 }} className="track-div">
                  <ChimneyName user={track} asLink={false} />: "<Link to={`/${track.id}`}>{track.title}</Link>" by {track.artist}
                </div>
              );
            })}
          {!threeYearsAgo || (threeYearsAgo.length === 0 && <div>No tracks were posted...</div>)}
        </Col>
      </Row>
    </Col>
  </Row>
);

export default TracksOnThisDay;
